





























































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { IDropdownItem } from "@/models/interfaces/dropdown";

import Checkbox from "@/components/BaseCheckbox/BaseCheckbox.vue";
import { isEmpty, isNil } from "ramda";

import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import EventBus, { Events } from "@/utils/helpers/EventBus";

@Component({
  components: {
    Checkbox,
    BaseSpinner
  }
})
export default class Dropdown extends Vue {
  @Prop({ type: String, default: "" })
  private placeholder!: string;

  @Prop({ default: true })
  private readonly!: boolean;

  @Prop({ default: false, type: Boolean })
  private clearable!: boolean;

  @Prop({ default: false })
  private multiple!: boolean;

  @Prop({ default: false })
  private disabled!: boolean;

  @Prop({ required: true })
  private value!: string | string[];

  @Prop({ default: "Select all" })
  private selectAll!: string;

  @Prop({ default: () => [] })
  private items!: IDropdownItem[];

  @Prop({ default: "", type: String })
  private error!: string;

  @Prop({ default: false, type: Boolean })
  private loading!: boolean;

  private showList = false;

  private selectedItems: string[] = [];

  private get computedItems() {
    return this.multiple && this.items.length
      ? [{ value: "all", label: this.selectAll }, ...this.items]
      : this.items;
  }

  private get getValue() {
    return this.selectedItems
      .map(value => this.items.find(item => item.value === value)?.label)
      .filter(value => value !== undefined)
      .join(", ");
  }

  private isSelected(item: IDropdownItem) {
    return Boolean(
      this.selectedItems.find(selectedItem => selectedItem === item.value)
    );
  }

  private selectItem(item: IDropdownItem) {
    const isSelectingAll = item.value === "all";
    const isAllSelected = this.selectedItems.length === this.items.length;

    if (this.multiple) {
      if (isSelectingAll) {
        const value = isAllSelected ? [] : this.items.map(item => item.value);
        this.selectedItems = value;
      } else if (this.isSelected(item)) {
        this.selectedItems = this.selectedItems.filter(id => id !== item.value);
      } else {
        this.selectedItems = [...this.selectedItems, item.value];
      }

      this.$emit("input", this.selectedItems);
    } else {
      this.selectedItems = [item.value];
      this.closeList();

      this.$emit("input", this.selectedItems[0]);
    }
  }

  public openList() {
    if (!this.disabled) {
      EventBus.$emit(Events.DropdownCloseAll);

      this.$nextTick(() => {
        this.showList = true;
      });
    }
  }

  public closeList(e?: Event) {
    this.showList = false;
  }

  public toggleList() {
    if (!this.disabled) {
      this.showList = !this.showList;
    }
  }

  private setValue() {
    const value = isEmpty(this.value) || isNil(this.value) ? [] : this.value;

    this.selectedItems = Array.isArray(value) ? value : [value];
  }

  private reset() {
    this.selectedItems = [];

    this.$emit(
      "input",
      this.multiple ? this.selectedItems : this.selectedItems[0]
    );
  }

  private created() {
    this.setValue();
  }

  public mounted() {
    document.addEventListener("click", this.closeList);

    EventBus.$on(Events.DropdownCloseAll, this.closeList);
  }

  public destroyed() {
    document.removeEventListener("click", this.closeList);
    EventBus.$off(Events.DropdownCloseAll, this.closeList);
  }

  @Watch("value")
  private onValueChanged(val: string) {
    if (!val || !val.length) {
      this.setValue();
    }
  }

  @Watch("disabled")
  private onDisabed(val: boolean) {
    if (val) {
      this.closeList();
    }
  }
}
